import { CueCounter, CuePreparedActivityItem } from 'src/app/models/fincas/cue.model';

/** Builds concise CUE activity summaries for the modal. */
export class CueSummaryPresenter {
  public static counterNumber(value: number | string | null): number {
    const numericValue = Number(value ?? 0);

    return Number.isFinite(numericValue) ? numericValue : 0;
  }

  public static pendingTaskCount(counter: CueCounter): number {
    return CueSummaryPresenter.counterNumber(counter.fito) + CueSummaryPresenter.counterNumber(counter.ferti);
  }

  public static preparedItems(counter: CueCounter): CuePreparedActivityItem[] {
    const phytoCount = CueSummaryPresenter.counterNumber(counter.fito);
    const fertilizationCount = CueSummaryPresenter.counterNumber(counter.ferti);

    return [
      {
        count: phytoCount,
        icon: 'pi pi-shield',
        label: 'Tratamientos fitosanitarios',
        text: phytoCount + ' tratamientos fitosanitarios preparados'
      },
      {
        count: fertilizationCount,
        icon: 'pi pi-sparkles',
        label: 'Fertilizaciones',
        text: fertilizationCount + ' fertilizaciones preparadas'
      }
    ];
  }

  public static preparedSummary(counter: CueCounter): string {
    const items = CueSummaryPresenter.preparedItems(counter);
    const totalCount = CueSummaryPresenter.pendingTaskCount(counter);

    if (totalCount === 0) {
      return 'No hay actividades pendientes de envío.';
    }

    return items
      .filter((item) => item.count > 0)
      .map((item) => '✓ ' + item.text)
      .join('\n');
  }
}
